import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_connectable_type } from '../../../_base/_methods/ENUM__field_connectable_type';
import { FIELD_PRIMITIVE__string_hash_sha256 } from './FIELD_PRIMITIVE__string_hash_sha256';

// todo: if node updated -> update value and it is output -> update value and all values forward
//todo if it is input and no edges connected -> set empty value
//todo: if it is input and edge connected -> set value of connected edge

//todo: calc on server second time hash and throw error if missmatch

//represents hash of image generated settings
export class FIELD_PRIMITIVE__string_hash_image_generated extends FIELD_PRIMITIVE__string_hash_sha256 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_STRING_HASH_IMAGE_GENERATED;

  /*
   * METHODS
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.STRING_HASH_IMAGE_GENERATED;
  }
}
